// export default function Page(){
//   return (
//     <div className="page">
//       <h1>About Us</h1>
//       <p>Dummy content for About Us.</p>
//       <img src="https://via.placeholder.com/800x300" alt="dummy"/>
//     </div>
//   );
// }

import React from "react";
import "../styles/about_us.css";
import heroImage from "../assets/images/hero-banner.jpg";
import trustdrive from "../assets/images/trustdrive.jpg";
import securityImg from "../assets/images/security.jpg";
import Aboutusheroimage from "../assets/images/Aboutus-heroimage.jpg";
import logo from "../assets/images/logo.jpeg";

const About = () => {
  return (
    <div className="about-page">
      {/* HERO SECTION */}
      <section className="about-hero">
        <div className="about-hero-left">
          <h1>Expert Security and Facilities Management Across the UK</h1>
          <p>
            At COLIPS, we specialise in providing top-tier security and
            facilities management services for businesses and homes across the
            UK. From advanced security solutions to comprehensive property
            maintenance, our expert team ensures your premises are safe,
            efficient, and well-managed.
          </p>

          <a href="/contact" className="about-btn">
            Get In Touch
          </a>
        </div>

        <div className="about-hero-right">
          <img src={Aboutusheroimage} alt="About Hero" />
        </div>
      </section>

      {/* STORY SECTION */}
      <section className="about-story">
        <div className="about-story-image">
          <img src={trustdrive} alt="Our Team" />
        </div>

        <div className="about-story-content">
          <h2>Built on Trust, Driven by Excellence</h2>

          <p>
            Being a family-owned business, COLIPS prioritises relationships over
            transactions. We’re committed to supporting our clients and
            communities through reliable, professional services that are rooted
            in integrity, respect, and accountability. Our goal is to deliver
            seamless security and facilities management solutions that give
            peace of mind and maintain a welcoming environment for everyone.
          </p>

          {/* <p>
            We understand the pressures of demanding work environments and are
            committed to providing guidance, support, and care for both our
            clients and staff. Our goal is to create safe, welcoming, and
            well-maintained spaces for everyone.
          </p> */}
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="about-cta">
        <div className="about-cta-left">
          <h2>Your Safety and Efficiency, Our Priority</h2>
          <p>
            From secure entrances to fully maintained facilities, COLIPS ensures
            every aspect of your property runs smoothly. Our proactive approach
            prevents issues before they arise, keeping your space secure,
            functional, and welcoming.
          </p>

          <a href="/contact" className="about-btn">
          Learn More
          </a>
        </div>

        <div className="about-cta-right">
          <img src={logo} alt="Site Work" />
        </div>
      </section>
    </div>
  );
};

export default About;
